import { useState } from "react";

import { Button, FeedbackBar, FlexRow } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import { ADDON_TYPE_NAME_DICT } from "app/contexts/AddonStateContext/const";
import { ADDON_HUB_PRESELECT_DEFAULTS } from "app/contexts/NoTouchPurchaseContext/useNoTouchPurchaseProvider";
import { translate } from "app/filters/i18nFilter";
import { goToAddonsPage } from "app/UtilitiesAndConstants/UtilityFunctions/goToAddonsPage";
import { hasAddonsEnabled, isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import { StyledCloseButton } from "./styles";
import { getCurrentMonth, shouldShowBanner, STORAGE_KEY } from "./utils";

const NoTouchAddonBanner = () => {
    const isNTUser = isNoTouch(swSettings);

    const [isVisible, setIsVisible] = useState(() => shouldShowBanner());

    const handleClose = () => {
        const currentMonth = getCurrentMonth();
        localStorage.setItem(STORAGE_KEY, currentMonth);
        setIsVisible(false);
    };

    const handleExploreClick = () => {
        if (!hasAddonsEnabled(swSettings)) {
            return;
        }
        goToAddonsPage({
            packageIds: [ADDON_HUB_PRESELECT_DEFAULTS[ADDON_TYPE_NAME_DICT.AdditionalUsersDynamic]],
        });
    };

    const shouldRender = isNTUser && isVisible;

    if (!shouldRender) {
        return null;
    }

    return (
        <FeedbackBar
            data-automation="si-home-nt-addon-banner"
            iconSrc="rocket-img"
            buttonComponent={
                <FlexRow>
                    <Button
                        data-automation="si-home-nt-addon-banner-explore"
                        onClick={handleExploreClick}
                        type="inverted"
                        width="max-content"
                    >
                        {translate("si.home.banner.explore-add-ons.button")}
                    </Button>

                    <StyledCloseButton
                        data-automation="si-home-nt-addon-banner-dismiss"
                        onClick={handleClose}
                        type="flat"
                        iconName="clear"
                    />
                </FlexRow>
            }
        >
            {translate("si.home.banner.explore-add-ons.description")}
        </FeedbackBar>
    );
};

export default NoTouchAddonBanner;
